export function getStatusBackground(statusId) {
	switch (statusId) {
		case 1:
			return '#879193';
		case 2:
			return '#bddf57';
		case 3:
			return '#4a6fb3';
		case 4:
			return '#fccb05';
		case 5:
			return '#000000';
		case 6:
			return '#7f5f3c';
		case 7:
			return '#ff9000';
		case 8:
			return '#c979f2';
		case 9:
			return '#cd3101';
		case 10:
			return '#bddf57';
		case 11:
			return '#72cdfa';
		case 12:
			return '#e7a0ae';
		case 13:
			return '#9966ff';
		case 14:
			return '#fccb05';
		default:
			return '#879193';
	}
}
